import { inject, Injectable, signal } from '@angular/core';

import { PlatformConfigService } from '../config/config.service';

const SIDEBAR_OPEN_CACHE_KEY = 'evcnt_sidebar_open';

@Injectable({ providedIn: 'root' })
export class SidebarPreferenceService {
  readonly #platformConfigService = inject(PlatformConfigService);

  readonly #sidebarOpen = signal<boolean | undefined>(undefined);
  readonly userPreference = this.#sidebarOpen.asReadonly();

  constructor() {
    const cachedPreference = this.#platformConfigService.get(SIDEBAR_OPEN_CACHE_KEY, true);

    if (typeof cachedPreference === 'boolean') {
      this.#sidebarOpen.set(cachedPreference);
    }
  }

  selectSidebarPreference(sidebarOpen: boolean): void {
    if (this.#sidebarOpen() === sidebarOpen) return;

    this.#sidebarOpen.set(sidebarOpen);
    this.#platformConfigService.set(SIDEBAR_OPEN_CACHE_KEY, sidebarOpen, true);
  }
}
